import React from 'react';

// Types
import { GoalItem } from 'Shared/constants/types';
import { ViewType } from '../GoalProgress/GoalProgress';

// Hooks
import { useGoal } from 'Shared/utils/hooks/use-goal';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

// Components
import GoalProgressWrapper from '../GoalProgressWrapper/GoalProgressWrapper';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

type Props = {
  goal: GoalItem;
  showEmptyState?: boolean;
  includeType?: boolean;
  view?: ViewType;
};

const GoalSubGoalProgress = ({ goal, showEmptyState = false, view = 'table' }: Props) => {
  const { tr } = useTranslation();
  const { subGoals } = useGoal({ slug: goal.slug });
  const hasSubGoals = subGoals.length > 0;
  if (!hasSubGoals && showEmptyState)
    return (
      <EmptyStateContainer
        subTitle={tr('perform.goals.sub_goals.empty_state_message')}
        grayBackground
        padding="025"
        inContainer
      />
    );

  if (!hasSubGoals) return null;

  const totalNumberOfCompleteSubGoals = subGoals.filter(goal => goal.complete).length;
  const totalNumberOfSubGoals = subGoals.length;

  const percent = Math.round((totalNumberOfCompleteSubGoals * 100) / totalNumberOfSubGoals);

  if (view === 'table') return <GoalProgressWrapper percent={percent} />;
  if (view === 'panel')
    return (
      <GoalProgressWrapper
        percent={percent}
        topLabel={{
          label: `${percent}%`,
          size: 'md',
        }}
        bottomLabel={{
          label: tr(
            'perform.goals.sub_goals.progress_label',
            totalNumberOfCompleteSubGoals.toString(),
            totalNumberOfSubGoals.toString()
          ),
        }}
      />
    );
  if (view === 'page')
    return (
      <GoalProgressWrapper
        percent={percent}
        progressBarSize="md"
        inlineEndLabel={{
          label: tr(
            'perform.goals.sub_goals.progress_complete_label',
            totalNumberOfCompleteSubGoals.toString(),
            totalNumberOfSubGoals.toString()
          ),
          size: 'sm',
        }}
        topLabel={{
          label: `${percent}%`,
          size: 'lg',
        }}
      />
    );
};

export default GoalSubGoalProgress;
